<template>
  <div id="company_module">
    <div class="cpmpany_banner">
      <img :src="bannerImg" width="100%" alt="">
    </div>
    <div class="company_cup">
      <el-row :gutter="30">
        <el-col :span="5">
          <div class="com_left_cup">
            <div v-for="(item,index) in comMduleArr" :key="index" class="com_item_name" @click="comModule(index)">
              {{item.module}}
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="com_summary_content">
            <div v-show="isVideo">
              <company-videos></company-videos>
            </div>
            <div v-show="isLeader">
              <company-leaders></company-leaders>
            </div>
            <div v-show="isSummary">
              <p class="company_summary" v-html="summaryText"></p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { eventBus } from '../../../common/util/eventBus.js';
import IMGSTATION from '../../../common/util/imgStation';
import { companySummaryInfos } from '@/api/enFrontApi/company';
import $ from 'jquery';
import companyLeaders from './companyLeaders';
import companyVideos from './companyVideos';
export default {
  data() {
    return {
      bannerImg: IMGSTATION.enAboutUsHead,
      comMduleArr: [
        { module: 'About IAIC' },
        { module: 'Leadership' },
        { module: 'Video Center' }
      ],
      isLeader: false,
      isVideo: false,
      isSummary: true,
      summaryText: '',
      summaryTitle: '公司简介',
      sumType: null,
      videosArr: []
    };
  },
  components: {
    companyLeaders,
    companyVideos
  },
  created() {
    this.getRouterData();
    eventBus.$on('enCompanyMdulePlayer', message => {
      this.sumType = message;
    });
    this.getSummary(3);
  },
  watch: {
    sumType: {
      handler(newVal) {
        this.comModule(this.sumType - 1);
      },
      deep: true
    }
  },
  mounted() {
    if (this.sumType) {
      this.comModule(this.sumType - 1);
    } else {
      this.comModule(0);
    }
  },
  methods: {
    getRouterData() {
      this.sumType = this.$route.params.sumType;
    },
    comModule(index) {
      $('.com_item_name')
        .eq(index)
        .addClass('back_backup');
      $('.com_item_name')
        .not(`:eq(${index})`)
        .removeClass('back_backup');
      switch (index) {
        case 0:
          this.isLeader = false;
          this.isVideo = false;
          this.isSummary = true;
          break;
        case 1:
          this.isLeader = true;
          this.isVideo = false;
          this.isSummary = false;
          break;
        case 2:
          this.isLeader = false;
          this.isVideo = true;
          this.isSummary = false;
          break;
      }
    },
    getSummary(dataType) {
      companySummaryInfos({ companyOrder: dataType }).then(res => {
        if (res) {
          this.summaryText = res.data.companyBody;
          // this.summaryTitle = res.data.companyName;
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
#company_module {
  width: 100%;
  min-height: 600px;
}

.cpmpany_banner {
  width: 100%;
}

.com_summary_title {
  text-align: center;
}

.company_cup {
  width: 70%;
  margin: 0 auto;
  padding: 15px 0 25px 0;

  .com_left_cup {
    text-align: center;
    background-color: #fff;
    border-left: 1px solid #DCDFE6;
    border-right: 1px solid #DCDFE6;
    border-top: 1px solid #DCDFE6;

    .com_item_name {
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #DCDFE6;
      font-size: 16px;
      cursor: pointer;
    }

    .com_item_name:hover {
      color: #fff;
      background-image: url('../../../../static/img/companyinfors/abu-bak.png');
    }
  }

  .com_summary_content {
    padding: 10px 20px;
    background-color: #fff;
  }
}

.back_backup {
  color: #fff;
  background-image: url('../../../../static/img/companyinfors/abu-bak.png');
}

.company_summary {
  text-indent: 2em;
  line-height: 30px;
  color: #000;
}

.company_summary>>>p {
  width: 100%;
}

.company_summary>>>p img {
  display: block;
  width: 90%;
  margin-left: 5%;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/companyInfos/company.vue